import React, { useState, useRef } from 'react'
import './Updatedetails.css'
import { useNavigate } from 'react-router-dom';

import DataLibraryManagement from "../../../Services/DataLibraryService/DataLibraryService"
import showToast from '../../../Utils/Toast/ToastNotification';
import { useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { showLoader, hideLoader } from '../../../Redux/Slice/Loader/loaderSlice';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';
import { useEffect } from 'react';
import Pagination from '../../Pagination/Pagination';
import searchbtn from '../../../Assets/images/search.svg'
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';

const Updatedatalibrary = () => {

    const maxColumns = 10

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { id } = useParams();

    const token = useSelector(
        (state) => state.auth?.user?.data?.body?.data?.token
    );

    useEffect(() => {
        if (id) {
            getDataLibraryById();
        }
    }, [id]);

    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [debouncedSearch, setDebouncedSearch] = useState("");

    const [nameError, setNameError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [columns, setColumns] = useState(['Category']);
    const [rows, setRows] = useState([['']]);

    const [rowsToExport, setRowsToExport] = useState([['']]);


    const [searchQuery, setSearchQuery] = useState("");


    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(e.target.value);
        setPage(0);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setPage(0);
    };

    const [sortBy, setSortBy] = useState("category");
    const [sortOrder, setSortOrder] = useState("ASC");
    const handleSort = (column) => {
        if (sortBy === column) {
            setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
        } else {
            setSortBy(column);
            setSortOrder("ASC");
        }
    };

    const handleAddColumn = () => {
        const newColumn = { name: '', isNewColumn: true }; // Mark new column
        setColumns(prevColumns => [...prevColumns, newColumn]);
        setRows(prevRows =>
            prevRows.map(row => [...row, { value: '', isNewColumn: true }]) // Mark new column cells
        );
    };

    const [removedHeaderIds, setRemovedHeaderIds] = useState([]);

    const handleRemoveColumn = (colIndexToRemove) => {
        // First, get the column (header) you're removing
        const removedColumn = columns[colIndexToRemove];

        // Save or log its ID if it has one
        const removedHeaderId = removedColumn?.id;

        // Optionally store in state if you want to track multiple removals
        setRemovedHeaderIds(prev => [...prev, removedHeaderId]); // <-- This requires you to have `removedHeaderIds` in state

        // Now remove from columns and rows
        setColumns(prev => prev.filter((_, i) => i !== colIndexToRemove));
        setRows(prevRows =>
            prevRows.map(row => row.filter((_, i) => i !== colIndexToRemove))
        );
    };


    const [newHeaders, setNewHeaders] = useState([]);

    const handleHeaderChange = (index, newValue) => {
        const updated = [...columns];
        updated[index] = { ...updated[index], name: newValue }; // safely update

        // Extract names of columns without an id
        const headersWithoutId = updated
            .filter(col => col.id === undefined)
            .map(col => col.name)
            .filter(name => name !== undefined);
        setNewHeaders(headersWithoutId);

        setColumns(updated);

        const changedHeader = {
            id: updated[index].id,
            name: newValue
        };

        setUpdatedHeaders(prev => {
            // Remove previous entry for the same ID, if it exists
            const filtered = prev.filter(h => h.id !== changedHeader.id);
            const newArr = [...filtered, changedHeader];

            if (newArr.id === undefined) {
                setNewHeaders((prevHeaders) => [...prevHeaders, newArr.name]);
            }

            return newArr;
        });
    };

    const [modifiedRecords, setModifiedRecords] = useState([]);

    const handleCellChange = (rowIndex, colIndex, newValue) => {
        const updatedRows = [...rows];

        // Extract cellId and isCategory after confirming the cell's validity
        const cellId = updatedRows[rowIndex][colIndex].id;
        const isCategory = updatedRows[rowIndex][colIndex].isCategory;

        // Update the cell's value
        updatedRows[rowIndex][colIndex] = { ...updatedRows[rowIndex][colIndex], value: newValue };
        setRows(updatedRows);

        // Update modifiedRecords
        setModifiedRecords((prevRecords) => {
            const existingRecordIndex = prevRecords.findIndex(record => record.id === cellId);
            if (existingRecordIndex !== -1) {
                const updatedRecords = [...prevRecords];
                updatedRecords[existingRecordIndex] = { ...updatedRecords[existingRecordIndex], value: newValue };
                return updatedRecords;
            } else {
                return [...prevRecords, { id: cellId, value: newValue, isCategory }];
            }
        });
    };


    const handleAddRow = () => {
        const newRow = columns.map(() => ({ value: '', isNewRow: true }));
        setRows(prevRows => [...prevRows, newRow]);
    };

    const [removedCategoryIds, setRemovedCategoryIds] = useState([]);

    const handleRemoveRow = (rowIndex) => {
        const removedRow = rows[rowIndex];
        const removedCategoryId = removedRow?.[0]?.id; // Assuming category ID is in the first cell
        setRemovedCategoryIds(prev => [...prev, removedCategoryId]); // Optional: store for later use
        const updatedRows = rows.filter((_, idx) => idx !== rowIndex);
        setRows(updatedRows);
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        let isValid = true;
        if (!name.trim()) {
            isValid = false
            setNameError("Name is required");
            return;
        }
        if (!description.trim()) {
            isValid = false
            setDescriptionError("Description is required");
            return;
        }

        // for the data library headers 
        for (const headerObj of columns) {
            const header = headerObj?.name?.trim() || '';

            // Check for leading space
            if (/^\s/.test(headerObj.name)) {
                showToast('error', `Leading spaces are not allowed in header: "${header}"`);
                isValid = false;
                break;
            }

            // Check for trailing space
            if (/\s$/.test(headerObj.name)) {
                showToast('error', `Trailing spaces are not allowed in header: "${header}"`);
                isValid = false;
                break;
            }

            // Check for space between words
            if (/\w\s+\w/.test(header)) {
                showToast('error', `Spaces between words are not allowed in header: "${header}"`);
                isValid = false;
                break;
            }
        }


        if (!isValid) return;

        const headers = columns;

        const headerNameToId = {};
        headers.forEach(header => {
            headerNameToId[header.name] = header.id;
        });
        const hasEmptyHeader = columns.some(header => !header || header?.name.trim() === '');
        if (hasEmptyHeader) {
            showToast('error', 'Please fill in all column headers before submitting.');
            isValid = false;
        }
        if (!isValid) return;

        // return 1
        const newRows = rows.filter(row => row.some(cell => cell.isNewRow));

        const newRowsData = newRows.map(row => {
            const category = row[0]?.value || '';
            const values = {};

            columns.slice(1).forEach((col, i) => {
                const colName = col.name || '';
                const headerId = headerNameToId[colName] || null;
                values[colName] = {
                    id: headerId,
                    value: row[i + 1]?.value || ''
                };
            });

            return {
                Category: category,
                values
            };
        });

        const categoryCount = {};

        for (const row of newRowsData) {
            const category = row.Category?.trim();

            if (!category) continue;

            if (categoryCount[category]) {
                categoryCount[category]++;
            } else {
                categoryCount[category] = 1;
            }
        }

        // Find duplicates
        const duplicates = Object.keys(categoryCount).filter(
            category => categoryCount[category] > 1
        );

        if (duplicates.length > 0) {
            const dupesList = duplicates.join(", ");
            showToast("error", `Duplicate entry of ${dupesList}`);
            return; // Exit or prevent further submission
        }

        const categoryToRowIdMap = {};

        rows.forEach(row => {
            const categoryCell = row.find(cell => cell.isCategory);
            if (categoryCell) {
                categoryToRowIdMap[categoryCell.value] = categoryCell.id;
            }
        });

        const newColumns = columns
            .map((col, i) => ({ ...col, index: i }))
            .filter(col => col.isNewColumn);

        const newColumnValues = newColumns.map(col => {
            const values = rows.map(row => {
                const categoryCell = row.find(cell => cell.isCategory);
                const category = categoryCell?.value || '';
                const rowId = categoryToRowIdMap[category] || null;
                const value = row[col.index]?.value || '';

                return {
                    rowId,
                    value,
                };
            });

            return {
                header: col.name,
                values,
            };
        });

        // Prepare the payload
        const payload = {
            name,
            description,
            headers: columns.map(col => col.name), // All headers
            newHeaders: newColumns.map(col => col.name), // Newly added headers
            newRows: newRowsData, // Newly added rows
            newColumnValues: newColumnValues,
            updatedCellValues: modifiedRecords, // Cells that have been modified
            updatedHeaderValues: updatedHeaders, // Headers that have been modified
            dataLibraryId: id,
            removedHeaderIds: removedHeaderIds,
            removedCategoryIds: removedCategoryIds
        };


        try {
            const response = await DataLibraryManagement.updateDataLibraryById(payload, token); // Pass `id`
            if (response?.data.statusCode === 200) {
                showToast("success", response.data.body.message);
                getDataLibraryById()
            } else {
                showToast("error", response.body.message);
            }
        } catch (error) {
            await HandleApiError(error);
        }

    };

    const handleBack = () => {
        navigate(-1); // Goes back one page in history
    };
    useEffect(() => {
        // Perform any additional actions with modifiedRecords here
    }, [modifiedRecords]);
    const [updatedHeaders, setUpdatedHeaders] = useState([]);

    const getDataLibraryById = async () => {
        dispatch(showLoader());
        try {

            const params = {
                id: id,
                search_text: searchQuery || "",
                page: page + 1,
                limit: rowsPerPage,
                sort_by: sortBy,
                sort_order: sortOrder
            }

            const response = await DataLibraryManagement.getDataLibraryById(params, token);

            if (response?.data?.statusCode === 200) {
                const { name, description, headers, rows } = response.data.body.data;

                setRowsToExport(rows)
                setName(name);
                setDescription(description);
                setColumns(headers);

                // Convert the row data format back to a 2D array
                const formattedRows = rows.map((row) => {
                    const rowArray = [];

                    // Add Category with its id
                    rowArray.push({
                        value: row.Category,
                        id: row.id, // Assuming the row's id corresponds to the Category,
                        isCategory: true
                    });

                    // Add values for other headers
                    headers.slice(1).forEach((header) => {
                        const cell = row.values[header.name];
                        rowArray.push({
                            value: cell ? cell.value : '',
                            id: cell ? cell.id : null, // Include the cell's id if it exists
                            isCategory: false
                        });
                    });

                    return rowArray;
                });

                setRows(formattedRows);

                setTotalRecords(response?.data?.body?.data?.pagination?.totalItems)
            } else {
                showToast("error", response.data.body?.message);
            }
        } catch (error) {
            await HandleApiError(error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const handleExport = async () => {
        if (!columns.length) return;

        try {
            dispatch(showLoader());

            const params = {
                id: id,
                search_text: searchQuery || "",
                page: 1,
                limit: totalRecords || 10000,
                sort_by: sortBy,
                sort_order: sortOrder
            };

            const response = await DataLibraryManagement.getDataLibraryById(params, token);

            if (response?.data?.statusCode === 200) {
                const allRows = response.data.body.data.rows;

                // ✅ Use exactly the columns from the config, in order
                const headerNames = columns.map(col => col.name);
                const data = [headerNames];

                allRows.forEach(row => {
                    const rowData = headerNames.map((header, index) => {
                        const valFromValues = row.values?.[header];

                        if (typeof valFromValues === 'object' && valFromValues !== null) {
                            return valFromValues.value ?? "";
                        } else if (valFromValues !== undefined) {
                            return valFromValues;
                        }

                        // 👇 Only for the first column, fallback to row.Category
                        if (index === 0 && row.Category) {
                            return row.Category;
                        }

                        return row[header] || "";
                    });
                    data.push(rowData);
                });


                const worksheet = XLSX.utils.aoa_to_sheet(data);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "DataLibrary");
                XLSX.writeFile(workbook, "data_library.xlsx");
            } else {
                showToast("error", response?.data?.body?.message || "Export failed");
            }
        } catch (error) {
            await HandleApiError(error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const closeButtonRef = useRef(null)

    const handleFileImport = (e) => {
        dispatch(showLoader());
        const file = e.target.files[0];
        if (!file) return;

        const fileName = file.name.toLowerCase();
        const isCSV = fileName.endsWith(".csv");

        const reader = new FileReader();
        reader.onload = (evt) => {
            let workbook;

            if (isCSV) {
                const csvData = evt.target.result;
                workbook = XLSX.read(csvData, { type: "binary" });
            } else {
                const data = new Uint8Array(evt.target.result);
                workbook = XLSX.read(data, { type: "array" });
            }

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const [headersRaw, ...rowsRaw] = jsonData;
            const importedHeaderNames = headersRaw.map(h => h.toString().trim());

            const columnNames = columns.map(col => col.name);
            const missingHeaders = importedHeaderNames.filter(header => !columnNames.includes(header));

            if (missingHeaders.length > 0) {
                const missingList = missingHeaders.join(", ");
                showToast("error", `Please add the following column first before importing: ${missingList}`);
                closeButtonRef.current.click();
                return;
            }

            // Step 1: Merge headers
            const updatedColumns = [...columns];
            importedHeaderNames.forEach(name => {
                const exists = updatedColumns.find(col => col.name === name);
                if (!exists) {
                    updatedColumns.push({
                        id: crypto.randomUUID(),
                        name
                    });
                }
            });

            setColumns(updatedColumns);

            // Step 2: Merge/update rows
            const updatedRows = [...rows];
            const newRowsToAdd = [];

            rowsRaw.forEach((rowRaw) => {
                const rowObj = {};
                importedHeaderNames.forEach((header, index) => {
                    rowObj[header] = rowRaw[index] || "";
                });

                const existingRowIndex = updatedRows.findIndex(
                    r => r[0]?.value === rowObj["Category"]
                );

                const newRowArray = updatedColumns.map((col) => {
                    const value = rowObj[col.name] || "";
                    const isCategory = col.name === "Category";
                    return {
                        value,
                        id: crypto.randomUUID(),
                        isCategory,
                        isNewRow: existingRowIndex === -1
                    };
                });

                if (existingRowIndex !== -1) {
                    updatedRows[existingRowIndex] = newRowArray;
                } else {
                    newRowsToAdd.push(newRowArray);
                }
            });

            const finalRows = [...updatedRows, ...newRowsToAdd];
            setRows(finalRows);

            if (closeButtonRef.current) {
                closeButtonRef.current.click();
                dispatch(hideLoader());
            }
        };

        if (isCSV) {
            reader.readAsBinaryString(file);
        } else {
            reader.readAsArrayBuffer(file);
        }
    };

    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, (txt) =>
            txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
        );
    };


    useEffect(() => {
        getDataLibraryById();
    }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder])

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchQuery]);

    return (
        <>
            <div className='main-inner-block'>
                <div className='content'>
                    {/* <div className='heading-content mt-0 mb-3'>
                        <button
                            className='green-btn back-button'
                            onClick={handleBack}
                        >
                            <i className="fas fa-arrow-left" style={{ marginRight: '1px' }}></i>
                            Back
                        </button>
                    </div> */}
                    <div className='d-flex align-items-center justify-content-between mb-4 block-one'>
                        <div className='heading-content mt-0'>
                            Update Data Library
                        </div>
                    </div>

                    <div className='white-box bg-box-mob'>

                        <form onSubmit={handleUpdate}>
                            <div className="create-library-block">

                                {/* <div className='input-search-box position-relative text-end'>
                                    <input
                                        type="text"
                                        id="name"
                                        placeholder="Search"
                                        value={searchQuery}
                                        onChange={handleSearch}
                                    />
                                    <div className='searchbtn search-data-lbrary'>
                                        <img src={searchbtn} alt="searchbtn"></img>
                                    </div>
                                    {searchQuery && (
                                        <button
                                            className="clear-btn"
                                            onClick={() => setSearchQuery("")}
                                        >
                                            ✖
                                        </button>
                                    )}
                                </div> */}

                                <div className="add-project-area d-flex flex-wrap align-items-center justify-content-between">
                                    <div className='d-flex align-items-center gap-4'>
                                        <div className="data-library-box">
                                            <label htmlFor="name" className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="Enter Name Here"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                            {nameError && <small className="text-danger">{nameError}</small>}
                                        </div>
                                        <div className="add-project-box update-details update-lib-textbox">
                                            <label htmlFor="description" className="form-label">Descriptions</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="description"
                                                style={{ height: '38px' }}
                                                placeholder="Pats Library"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                            {descriptionError && <small className="text-danger">{descriptionError}</small>}
                                        </div>
                                    </div>

                                    <div className='export-excel d-flex flex-wrap align-items-center gap-3'>
                                        <button
                                            type='button'
                                            className="green-btn green-signin addnewuser excel-icon mt-2"
                                            onClick={handleExport}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                                <path fill="#217346" d="M4 2h10l6 6v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                                                <path fill="#fff" d="M14 3.5V8h4.5L14 3.5z" />
                                                <path fill="#fff" d="M8 10h1.2l1.1 2.1L11.5 10H13l-1.7 3 1.8 3h-1.5l-1.2-2.2-1.2 2.2H7.8l1.8-3L8 10z" />
                                            </svg>
                                            Export
                                        </button>

                                        <button
                                            className="green-btn green-signin addnewuser excel-icon mt-2"
                                            type='button'
                                            data-bs-toggle="modal"
                                            data-bs-target="#importModal"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
                                                <path fill="#217346" d="M4 2h10l6 6v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
                                                <path fill="#fff" d="M14 3.5V8h4.5L14 3.5z" />
                                                <path fill="#fff" d="M8 10h1.2l1.1 2.1L11.5 10H13l-1.7 3 1.8 3h-1.5l-1.2-2.2-1.2 2.2H7.8l1.8-3L8 10z" />
                                            </svg>

                                            Import
                                        </button>

                                        {/* <div className='input-search-box position-relative text-end'>
                                            <input
                                                type="text"
                                                id="name"
                                                placeholder="Search"
                                                value={searchQuery}
                                                onChange={handleSearch}
                                            />
                                            <div className='searchbtn search-data-lbrary'>
                                                <img src={searchbtn} alt="searchbtn"></img>
                                            </div>
                                            {searchQuery && (
                                                <button
                                                    className="clear-btn"
                                                    onClick={() => setSearchQuery("")}
                                                >
                                                    ✖
                                                </button>
                                            )}
                                        </div> */}



                                        <div className='input-search-box position-relative text-end search-control'>
                                            <input
                                                type="text"
                                                id="name"
                                                placeholder="Search"
                                                value={searchQuery}
                                                onChange={handleSearch}
                                            />
                                            <div className='searchbtn '>
                                                <img src={searchbtn} alt="searchbtn" />
                                            </div>
                                            {searchQuery && (
                                                <button
                                                    className="clear-btn"
                                                    onClick={() => setSearchQuery("")}
                                                >
                                                    ✖
                                                </button>
                                            )}
                                        </div>

                                        {/* Modal remains unchanged */}



                                        <div className="modal fade" id="importModal" tabIndex="-1" aria-labelledby="importModalLabel" aria-hidden="true">
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content p-3">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="importModalLabel">Import Excel</h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeButtonRef}></button>
                                                    </div>

                                                    <div className="modal-body">
                                                        <div className="mb-3">
                                                            <label htmlFor="excelFile" className="form-label">Choose Excel file</label>
                                                            <input
                                                                className="form-control"
                                                                type="file"
                                                                id="excelFile"
                                                                accept=".xlsx,.xls,.csv"
                                                                onChange={handleFileImport}
                                                            />
                                                        </div>
                                                        <p>
                                                            Sample Excel:{" "}
                                                            <a href="/data_library.xlsx" download="data_library.xlsx" style={{ textDecoration: "underline", color: "#217346" }}>
                                                                data_library.xlsx
                                                            </a>
                                                        </p>
                                                    </div>

                                                    <div className="modal-footer">
                                                        <button
                                                            type="button"
                                                            className="green-btn green-signin addnewuser"
                                                            data-bs-dismiss="modal"
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                </div>

                                <div className='category-table sm-box mt-4 table-responsive w-100'>
                                    <table className="table align-middle mb-0">
                                        <thead className="table-bg">
                                            <tr>
                                                {columns.map((col, i) => (
                                                    <th key={col.id || i} className="position-relative">
                                                        <div className="d-flex align-items-center">
                                                            <input
                                                                type="text"
                                                                // value={col.name ? toTitleCase(col.name) : ''}
                                                                value={col.name ? col.name : ''}
                                                                onChange={(e) => handleHeaderChange(i, e.target.value)}
                                                                className="form-control form-control-sm me-1"
                                                            />
                                                            {col.id && i == 0 && (
                                                                <span className="ms-1 sort" onClick={() => handleSort("category")} >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        version="1.1"
                                                                        width="10"
                                                                        height="17"
                                                                        viewBox="0 0 32 32"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                                                                                fill="#949494"
                                                                                opacity="1"
                                                                            />
                                                                        </g>
                                                                    </svg>
                                                                </span>
                                                            )}

                                                            {i > 0 && (
                                                                <div className="delete-icon cursor-pointer" onClick={() => handleRemoveColumn(i)}>
                                                                    {/* Delete Icon */}
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <path d="M2 4H3.33333H14" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M6.66602 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        <path d="M9.33398 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </th>
                                                ))}
                                                <th>
                                                    {columns.length < maxColumns && (
                                                        <a
                                                            className='add-category-box'
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleAddColumn();
                                                            }}
                                                        >
                                                            {/* Add Column Icon */}
                                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                <path
                                                                    d="M8.40039 3.33398V12.6673"
                                                                    stroke="#85BD58"
                                                                    strokeWidth="1.33333"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M3.73438 8H13.0677"
                                                                    stroke="#85BD58"
                                                                    strokeWidth="1.33333"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </a>
                                                    )}
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    {row.map((cell, colIndex) => (
                                                        <td key={cell.id || colIndex}>
                                                            <input
                                                                type="text"
                                                                value={cell.value || ''}
                                                                onChange={(e) => handleCellChange(rowIndex, colIndex, e.target.value)}
                                                                className="form-control form-control-sm"
                                                            />
                                                        </td>
                                                    ))}
                                                    <td>
                                                        <div className='delete-icon cursor-pointer' onClick={() => handleRemoveRow(rowIndex)}>
                                                            {/* Delete Icon */}
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M2 4H3.33333H14" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M12.6673 4.00065V13.334C12.6673 13.6876 12.5268 14.0267 12.2768 14.2768C12.0267 14.5268 11.6876 14.6673 11.334 14.6673H4.66732C4.3137 14.6673 3.97456 14.5268 3.72451 14.2768C3.47446 14.0267 3.33398 13.6876 3.33398 13.334V4.00065" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M6.66602 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M9.33398 7.33398V11.334" stroke="#E8514F" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan={columns.length + 1}>
                                                    <div className='add-row cursor-pointer' onClick={handleAddRow}>
                                                        <span className='me-2'>
                                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
                                                                <path d="M8.40039 3.33398V12.6673" stroke="#85BD58" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M3.73438 8H13.0677" stroke="#85BD58" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </span>
                                                        Add Row
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <button
                                    type="button"
                                    className="green-btn green-signin addnewuser mt-3"
                                    onClick={() => navigate("/datalibrary-listing")}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="green-btn green-signin addnewuser mt-3"
                                    style={{ marginLeft: "10px" }}
                                >
                                    Update
                                </button>
                            </div>
                        </form>

                        <div className="pagination-block">
                            {
                                <Pagination
                                    count={totalRecords}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Updatedatalibrary